import { cabsLandingWidgetInfo } from '../cabsLandingWidgetInfo';
import { SEO_CABS_LANDING_PAGE } from '../constants/templateConstants';
import {
  AT,
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS,
  getShortCode,
  isAirportCheck
} from '../constants/tripTypes';
import { isInternationalPage } from './commonUtils';
import { escapeRegexCharacters } from './stringUtils';
const {
  PLACES_AUTOCOMPLETE_URL,
  AIRPORT_AUTOCOMPLETE_URL,
  AUTOCOMPLETE_URL_V3
} = process.env;
export type CitiesList = CityListData[];

export const cityTypes = [
  //   'locality',
  'administrative_area_level_2',
  'administrative_area_level_1'
];

export type CityListData = {
  title: string;
  citieslist: CityData[];
};
export type CityData = {
  title: string;
  subTitle: string;
  placeId: string;
  cityCode: string;
  geoLocation?: any;
};

const cabsLandingLocationType = [
  cabsLandingWidgetInfo.FROM_AIRPORT_CITY_LOCATION_WIDGET,
  cabsLandingWidgetInfo.TO_AIRPORT_CITY_LOCATION_WIDGET,
  cabsLandingWidgetInfo.STOPOVER_CITY_LOCATION_WIDGET,
  cabsLandingWidgetInfo.RENTAL_PICKUP_LOCATION_WIDGET,
  cabsLandingWidgetInfo.OUTSTATION_PICKUP_LOCATION_WIDGET,
  cabsLandingWidgetInfo.OUTSTATION_DROP_LOCATION_WIDGET
];

const cabsLandingAirportType = [
  cabsLandingWidgetInfo.FROM_AIRPORT_LOCATION_WIDGET,
  cabsLandingWidgetInfo.TO_AIRPORT_LOCATION_WIDGET
];

const allowPlacesAutoComplete = (
  travelFor: string,
  widget: number | null,
  omniUrlArgs: string | null
): boolean => {
  if (widget == null || !omniUrlArgs) return false;

  if (omniUrlArgs && omniUrlArgs.includes(SEO_CABS_LANDING_PAGE))
    return cabsLandingLocationType.includes(widget);

  return (
    [OUTSTATION_ONE_WAY, OUTSTATION_ROUND_TRIP, RENTALS].includes(travelFor) ||
    (travelFor === CAB_TO_AIRPORT && widget === 0) ||
    (travelFor === CAB_FROM_AIRPORT && widget === 1)
  );
};

const allowAirportAutoComplete = (
  travelFor: string,
  widget: number | null,
  omniUrlArgs: string | null
): boolean => {
  if (widget == null || !omniUrlArgs) return false;

  if (omniUrlArgs && omniUrlArgs.includes(SEO_CABS_LANDING_PAGE))
    return cabsLandingAirportType.includes(widget);

  return isAirportCheck(travelFor);
};

const getErrorResponse = () => {
  return [
    {
      title: 'No Data Found',
      citieslist: [
        {
          title: 'Server Error',
          subTitle: '',
          placeId: '',
          cityCode: ''
        }
      ]
    }
  ];
};

export const getSuggestions = async (
  value: string,
  travelFor: string,
  widget: number | null,
  omniUrlArgs: string | null
): Promise<CitiesList | undefined> => {
  const escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  if (isInternationalPage() && getShortCode(travelFor) === AT) {
    let results = await fetch(
      `${AUTOCOMPLETE_URL_V3}?query=${value}&tripType=${getShortCode(
        travelFor
      )}&ohl=no`,
      { headers: { 'x-gommt-brand': 'MMT' } }
    )
      .then(res => res.json())
      .catch(e => []);
    if (results.response != undefined) {
      //   if (
      //     (travelFor === CAB_TO_AIRPORT && widget === 0) ||
      //     (travelFor === CAB_FROM_AIRPORT && widget === 1)
      //   ) {
      results = results.response.filter(data => !data.is_city);
      //   }
      return [
        {
          title: 'SEARCH RESULTS',
          citieslist: results.map(p => ({
            title: p.main_text,
            subTitle: p.secondary_text || '',
            placeId: p.place_id
          }))
        }
      ];
    }
    return getErrorResponse();
  } else {
    if (allowPlacesAutoComplete(travelFor, widget, omniUrlArgs)) {
      const results = await fetch(`${PLACES_AUTOCOMPLETE_URL}?query=${value}`)
        .then(res => res.json())
        .catch(e => []);
      if (results.data != undefined) {
        //   if (
        //     (travelFor === CAB_TO_AIRPORT && widget === 0) ||
        //     (travelFor === CAB_FROM_AIRPORT && widget === 1)
        //   ) {
        results.data = results.data.filter(
          data => !data?.types.filter(value => cityTypes.includes(value)).length
        );
        //   }
        return [
          {
            title: 'SEARCH RESULTS',
            citieslist: results.data.map(p => ({
              title: p.structured_formatting.main_text,
              subTitle: p.structured_formatting.secondary_text,
              placeId: p.place_id
            }))
          }
        ];
      }
      return getErrorResponse();
    } else if (allowAirportAutoComplete(travelFor, widget, omniUrlArgs)) {
      const url = `${AIRPORT_AUTOCOMPLETE_URL}/${value}`;
      const results = await fetch(url)
        .then(res => res.json())
        .catch(e => []);

      if (results.response != undefined) {
        return [
          {
            title: 'SEARCH RESULTS',
            citieslist: results.response.map(r => ({
              title: r.main_text,
              subTitle: r.secondary_text,
              placeId: r.place_id,
              cityCode: r.city_code
            }))
          }
        ];
      }
      return getErrorResponse();
    }
  }

  return getErrorResponse();
};
